import { useContext, useEffect } from 'react'

import { Route, Redirect } from 'react-router-dom'
import DashboardContext from '../../Context'

/**
 * این کامپوننت اگر کاربر لاگین باشد کاربر را به ادرس دیگه ای ارسال می کند
 *  اگر نباشد کامپوننت را نمایش داده می شود
 */
export default function UnAuthentication({ component: Component, ...rest }) {

    const { islogin, handelPatch } = useContext(DashboardContext)

    useEffect(() => {
        handelPatch(rest.path)
        return () => {

        };
    }, [rest.path]);
    return (

        <Route
            {...rest}
            render={props =>
                islogin ? (
                    <Redirect to={{ pathname: "/", state: { status: 302 } }} />
                ) : (
                    <Component {...props} />
                )
            }
        />
    )
}
